export default "__VITE_ASSET__C2ni0ZAD__"